export default __webpack_public_path__ + "static/media/Aura-Egg__95.49d9cb7f.png";